import { useNavigate, Link } from 'react-router-dom';
import { RotateCcw, Info } from 'lucide-react';
import { useStore, fmtIDR, fmtDate } from '../lib/store';
import { Money } from '../components/Bits';

export default function Settings() {
  const { state, resetAll } = useStore();
  const navigate = useNavigate();
  const p = state.profile;

  const reset = () => {
    if (window.confirm('Hapus semua data SebelumSah di perangkat ini? Tindakan ini tidak bisa dibatalkan.')) {
      resetAll();
      navigate('/');
    }
  };

  return (
    <div data-testid="settings-page" className="space-y-6">
      <h1 className="font-serif text-3xl font-semibold tracking-tight text-ink">Pengaturan</h1>

      <div className="rounded-2xl border border-ink/10 bg-white p-5">
        <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-terra mb-3">Profil Pernikahan</p>
        <p className="font-serif text-xl font-semibold text-ink">{p.coupleName}</p>
        <div className="mt-2 space-y-1 font-mono text-[11px] text-slate-500">
          <p>{fmtDate(p.weddingDate)}{p.city ? ` · ${p.city}` : ''}</p>
          {p.budget > 0 && <p>Budget <Money className="text-ink font-semibold">{fmtIDR(p.budget)}</Money></p>}
        </div>
        {p.demoMode && (
          <p className="mt-3 rounded-lg bg-gold/10 border border-gold/40 px-3 py-2 text-[11px] text-[#8a6d1c]">
            Mode Demo aktif — seluruh vendor dan pembayaran di sini fiktif, dibuat untuk mencoba alur aplikasi.
          </p>
        )}
      </div>

      <Link data-testid="settings-about-link" to="/app/tentang" className="card-lift flex items-center gap-3 rounded-2xl border border-ink/10 bg-white px-5 py-4">
        <Info size={17} className="text-terra" />
        <div>
          <p className="text-sm font-bold text-ink">Tentang SebelumSah</p>
          <p className="text-[11px] text-slate-500">Batasan verifikasi & prinsip kepercayaan</p>
        </div>
      </Link>

      <button data-testid="reset-data-btn" onClick={reset} className="w-full flex items-center justify-center gap-2 rounded-2xl border border-red-200 bg-white px-5 py-4 text-sm font-bold text-red-600 hover:bg-red-50 transition-colors">
        <RotateCcw size={15} /> Reset Data
      </button>
    </div>
  );
}
